import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface Props {
  reportId: string;
  caseId: string | null;
}

// really this should come from the backend, but we've used an enum there which makes things awkward, so it's here for now
export const inconsistencyReportDownloadColumnOptions = [
  { label: 'ID', value: 'ID' },
  { label: 'Inconsistency', value: 'Inconsistency' },
  { label: 'Inconsistency Type', value: 'Inconsistency Type' },
  { label: 'Source', value: 'Source' },
  { label: 'Severity', value: 'Severity' },
  { label: 'Fact Document Name', value: 'Fact Document Name' },
  { label: 'Fact Source Text', value: 'Fact Source Text' },
];

export const useDownloadInconsistencyReport = ({ reportId, caseId }: Props) => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadReport = async ({ format, title, columns }: { format: string; title: string; columns: string[] }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        format,
        caseId,
        title,
        columns,
      },
    });

    const response = await fetch(
      `${APIBaseChronos}/api/case/${caseId}/inconsistency-report/${reportId}/download`,
      fetchConfig,
    );

    if (!response.ok) {
      throw new Error('Failed to download inconsistency report');
    }

    const blob = await response.blob();

    const link = Object.assign(document.createElement('a'), {
      href: URL.createObjectURL(blob),
      download: `${title}.${format}`,
    });

    link.click();

    URL.revokeObjectURL(link.href);
  };

  const { mutate: fetchDownload, isLoading: isLoadingDownload } = useMutation(downloadReport, {
    onError: () => {
      toast.error('Failed to download inconsistency report. Please try again.');
    },
  });

  return { fetchDownload, isLoadingDownload };
};
